import { useEffect } from 'react';

import { shutdownSessionReplay } from './sessionReplayModule.ts';
import { sessionReplayState } from './sessionReplayState.ts';

// Stops Amplitude session replay once the user submits their first lineup
export const useSessionReplayShutdown = (hasCreatedFirstLineup: boolean) => {
  useEffect(() => {
    if (!sessionReplayState.active) return;
    if (hasCreatedFirstLineup) {
      shutdownSessionReplay();
      sessionReplayState.active = false;
    }
  }, [hasCreatedFirstLineup]);
};
